import styled, { css, DefaultTheme } from 'styled-components';

export default styled.div`
  ${() => {
  return css`
    .dropdown__list {
      padding: 0;
      margin: 0;
      list-style: none;
      min-width: 14em;
      background: var(--color-white);
      padding: 0.5em 0;
      border: 0.063em solid var(--color-neutral-30);
      box-shadow: var(--box-shadow);
      border-radius: 0.188em;
    }
    .dropdown__btn {
      width: 100%;
      font-weight: 400;
      font-size: 0.875em;
      line-height: 1.5em;
      font-family: inherit;
      background: none;
      border: none;
      padding: 0.75em 1em;
      text-align: left;
      color: var(--color-neutral-70);
      display: flex;
      align-items: center;
      &:hover {
        background: var(--color-neutral-20);
      }
      &:focus {
        outline: 0.125em solid transparent;
        box-shadow: inset 0 0 0 0.125em var(--a11y);
      }
    }
    .dropdown__btn svg {
      margin-right: 0.5em;
    }
    [data-dropdownactive='true'] {
      background: var(--color-neutral-20);
      &:hover {
        background: var(--color-neutral-20);
      }
    }
  `;
  }};
`;
